import type { QuoteCanvasData } from 'src/pages/_myAccount/Requests/Request/components/RequestCanvas/types'

const DEMO_T0 = Date.parse('2026-08-19T09:12:00.000Z')

type Locale = 'en' | 'sv'

const copy = (locale: Locale, en: string, sv: string) =>
  locale === 'sv' ? sv : en

const at = (seconds: number) =>
  new Date(DEMO_T0 + seconds * 1000).toISOString()

const HOODIE_SUB_ID = 1001
const TEE_SUB_ID = 1002
const TOTE_SUB_ID = 1003

export const buildDemoCanvasData = (locale: Locale): QuoteCanvasData => ({
  version: 1,
  positions: {
    [HOODIE_SUB_ID]: { x: 16, y: 32 },
    [TEE_SUB_ID]: { x: 300, y: 16 },
    [TOTE_SUB_ID]: { x: 80, y: 420 },
  },
  zOrder: [HOODIE_SUB_ID, TEE_SUB_ID, TOTE_SUB_ID],
  comments: [
    {
      id: 'demo-comment-hoodie',
      x: 40,
      y: 380,
      text: copy(
        locale,
        'Love the hoodie — can the chest print go one size up?',
        'Älskar hoodien — kan brösttrycket bli en storlek större?'
      ),
      createdAt: at(215),
    },
    {
      id: 'demo-comment-tote',
      x: 328,
      y: 548,
      text: copy(
        locale,
        'Tote is perfect for the welcome pack.',
        'Tygkassen är perfekt till välkomstpaketet.'
      ),
      createdAt: at(232),
    },
  ],
  files: [],
  links: [],
  strokes: [],
  stamps: [
    {
      id: 'demo-stamp-hoodie',
      x: 232,
      y: 48,
      emoji: '🔥',
      createdAt: at(220),
    },
    {
      id: 'demo-stamp-tee',
      x: 520,
      y: 36,
      emoji: '⭐',
      createdAt: at(224),
    },
    {
      id: 'demo-stamp-tote',
      x: 304,
      y: 440,
      emoji: '👍',
      createdAt: at(236),
    },
  ],
})
